import { Avatar, Grid, IconButton, Stack, Typography } from "@mui/material";
import { GreenVerifiedTick, MailGrayIcon, MapGrayIcon } from "../../../assets/images";
import { MuiStack } from "../../../components";
import { defaultMobile, EContactType } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { dateFormate } from "../../../utils/utils";
import SkeletonLoader from "../../../components/atoms/sketeton";
import React from "react";
var CardComponent = function (_ref) {
    var title = _ref.title, children = _ref.children;
    return /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "12px",
        fontWeight: "500",
        color: "#6A7682",
        pb: 1
    }, title), /*#__PURE__*/ React.createElement(Grid, {
        sx: {
            border: "1px solid #DEE4EB",
            borderRadius: "12px",
            padding: 1,
            position: "relative",
            width: {
                xs: "366px",
                sm: "310.67px",
                md: "440px"
            },
            height: "170px"
        }
    }, children));
};
var CardDetails = function (_ref2) {
    var label = _ref2.label, value = _ref2.value, isCustomer = _ref2.isCustomer;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "start",
        justifyContent: "space-between"
    }, !value ? /*#__PURE__*/ React.createElement(MuiStack, {
        "flex-direction": 'column',
        style: {
            width: '25vw',
            height: '3vh',
            padding: "1.5px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        pl: 1,
        fontSize: "12px",
        fontWeight: "500",
        color: "#8593A3"
    }, typeof label === "string" ? label + ":" : label), /*#__PURE__*/ React.createElement(Typography, {
        pl: 1,
        fontSize: "12px",
        fontWeight: "500",
        color: isCustomer ? "#8593A3" : "#1B1D21"
    }, value !== null && value !== void 0 ? value : "-")));
};
export var BasicDetailcards = function (_ref3) {
    var _customerDetails$data2, _customerDetails$data3, _customerDetails$data4, _customerDetails$data5, _primary$MobileNumber, _secondary$MobileNumb, _primary$Email, _customerDetails$data6, _customerDetails$data7, _customerDetails$data8, _customerDetails$data9, _jobcardDetailsByIdGe, _jobcardDetailsByIdGe2, _jobcardDetailsByIdGe3, _jobcardDetailsByIdGe4, _jobcardDetailsByIdGe5, _jobcardDetailsByIdGe6, _jobcardDetailsByIdGe7, _jobcardDetailsByIdGe8, _jobcardDetailsByIdGe9, _jobcardDetailsByIdGe10, _Installbasedetails$d, _Installbasedetails$d2, _Installbasedetails$d3, _Installbasedetails$d4, _Installbasedetails$d5, _Installbasedetails$d6, _Installbasedetails$d7, _Installbasedetails$d8, _Installbasedetails$d9, _Installbasedetails$d10, _Installbasedetails$d11, _Installbasedetails$d12;
    var hideJCDetails = _ref3.hideJCDetails;
    var _a = useAppSelector(function (state) { return state.crud; }), Installbasedetails = _a.Installbasedetails, customerDetails = _a.customerDetails, jobcardDetailsByIdGet = _a.jobcardDetailsByIdGet;
    var findContact = function (type) {
        var _customerDetails$data;
        return customerDetails === null || customerDetails === void 0 || (_customerDetails$data = customerDetails.data) === null || _customerDetails$data === void 0 || (_customerDetails$data = _customerDetails$data.PersonContactPoint) === null || _customerDetails$data === void 0 ? void 0 : _customerDetails$data.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ContactType) === type; });
    };
    var isValidMobile = function (mobile) { return mobile !== defaultMobile; };
    var primary = findContact(EContactType.Primary);
    var secondary = findContact(EContactType.Secondary);
    return /*#__PURE__*/ React.createElement(Grid, {
        gap: 1,
        container: true
    }, /*#__PURE__*/ React.createElement(CardComponent, {
        title: "Customer details"
    }, /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        sx: {
            position: "absolute",
            top: 8,
            right: 8
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Avatar, {
        sx: {
            width: "40px",
            height: "40px"
        }
    }), /*#__PURE__*/ React.createElement(Stack, {
        p: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "14px",
        fontWeight: "500"
    }, "".concat((_customerDetails$data2 = customerDetails === null || customerDetails === void 0 || (_customerDetails$data3 = customerDetails.data) === null || _customerDetails$data3 === void 0 || (_customerDetails$data3 = _customerDetails$data3.Person) === null || _customerDetails$data3 === void 0 ? void 0 : _customerDetails$data3.GivenName) !== null && _customerDetails$data2 !== void 0 ? _customerDetails$data2 : "-", " ").concat((_customerDetails$data4 = customerDetails === null || customerDetails === void 0 || (_customerDetails$data5 = customerDetails.data) === null || _customerDetails$data5 === void 0 || (_customerDetails$data5 = _customerDetails$data5.Person) === null || _customerDetails$data5 === void 0 ? void 0 : _customerDetails$data5.FamilyName) !== null && _customerDetails$data4 !== void 0 ? _customerDetails$data4 : "")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        spacing: 1
    }, isValidMobile(primary === null || primary === void 0 ? void 0 : primary.MobileNumber) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "12px",
        color: "#8593A3"
    }, (_primary$MobileNumber = primary === null || primary === void 0 ? void 0 : primary.MobileNumber) !== null && _primary$MobileNumber !== void 0 ? _primary$MobileNumber : "-"), (primary === null || primary === void 0 ? void 0 : primary.IsMobileVerified) && /*#__PURE__*/ React.createElement("img", {
        src: GreenVerifiedTick,
        alt: "Verified",
        height: "12px",
        width: "12px"
    })), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "12px",
        color: "#8593A3"
    }, "|"), isValidMobile(secondary === null || secondary === void 0 ? void 0 : secondary.MobileNumber) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "12px",
        color: "#8593A3"
    }, (_secondary$MobileNumb = secondary === null || secondary === void 0 ? void 0 : secondary.MobileNumber) !== null && _secondary$MobileNumb !== void 0 ? _secondary$MobileNumb : "-"), (secondary === null || secondary === void 0 ? void 0 : secondary.IsAlternateNumberVerified) && /*#__PURE__*/ React.createElement("img", {
        src: GreenVerifiedTick,
        alt: "Verified",
        height: "12px",
        width: "12px"
    })) : /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "12px",
        color: "#8593A3"
    }, "-")))), /*#__PURE__*/ React.createElement(MuiStack, {
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        gap: 1,
        pt: 1
    }, /*#__PURE__*/ React.createElement(CardDetails, {
        isCustomer: true,
        label: /*#__PURE__*/ React.createElement("img", {
            src: MailGrayIcon,
            alt: "mailicon",
            height: "14px",
            width: "14px"
        }),
        value: (_primary$Email = primary === null || primary === void 0 ? void 0 : primary.Email) !== null && _primary$Email !== void 0 ? _primary$Email : "-"
    }), /*#__PURE__*/ React.createElement(CardDetails, {
        isCustomer: true,
        label: /*#__PURE__*/ React.createElement("img", {
            src: MapGrayIcon,
            alt: "mapIcon",
            height: "16px",
            width: "16px"
        }),
        value: "".concat((_customerDetails$data6 = customerDetails === null || customerDetails === void 0 || (_customerDetails$data7 = customerDetails.data) === null || _customerDetails$data7 === void 0 || (_customerDetails$data7 = _customerDetails$data7.Address) === null || _customerDetails$data7 === void 0 || (_customerDetails$data7 = _customerDetails$data7[0]) === null || _customerDetails$data7 === void 0 ? void 0 : _customerDetails$data7.Address1) !== null && _customerDetails$data6 !== void 0 ? _customerDetails$data6 : "-", " ").concat((_customerDetails$data8 = customerDetails === null || customerDetails === void 0 || (_customerDetails$data9 = customerDetails.data) === null || _customerDetails$data9 === void 0 || (_customerDetails$data9 = _customerDetails$data9.Address) === null || _customerDetails$data9 === void 0 || (_customerDetails$data9 = _customerDetails$data9[0]) === null || _customerDetails$data9 === void 0 ? void 0 : _customerDetails$data9.Address2) !== null && _customerDetails$data8 !== void 0 ? _customerDetails$data8 : "")
    }))), !hideJCDetails && /*#__PURE__*/ React.createElement(CardComponent, {
        title: "Job card details"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "14px",
        fontWeight: "500"
    }, (_jobcardDetailsByIdGe = jobcardDetailsByIdGet === null || jobcardDetailsByIdGet === void 0 || (_jobcardDetailsByIdGe2 = jobcardDetailsByIdGet.data) === null || _jobcardDetailsByIdGe2 === void 0 ? void 0 : _jobcardDetailsByIdGe2.SourceDocumentNo) !== null && _jobcardDetailsByIdGe !== void 0 ? _jobcardDetailsByIdGe : "-"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "12px",
        color: "#8593A3"
    }, " ", jobcardDetailsByIdGet !== null && jobcardDetailsByIdGet !== void 0 && (_jobcardDetailsByIdGe3 = jobcardDetailsByIdGet.data) !== null && _jobcardDetailsByIdGe3 !== void 0 && _jobcardDetailsByIdGe3.JobCardDate ? dateFormate(jobcardDetailsByIdGet === null || jobcardDetailsByIdGet === void 0 || (_jobcardDetailsByIdGe4 = jobcardDetailsByIdGet.data) === null || _jobcardDetailsByIdGe4 === void 0 ? void 0 : _jobcardDetailsByIdGe4.JobCardDate) : "-"), /*#__PURE__*/ React.createElement(MuiStack, {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        sx: {
            backgroundColor: "#F4F7FA",
            borderRadius: "12px"
        },
        mt: 1,
        p: 1.5
    }, /*#__PURE__*/ React.createElement(CardDetails, {
        label: "Est. delivery",
        value: jobcardDetailsByIdGet !== null && jobcardDetailsByIdGet !== void 0 && (_jobcardDetailsByIdGe5 = jobcardDetailsByIdGet.data) !== null && _jobcardDetailsByIdGe5 !== void 0 && _jobcardDetailsByIdGe5.EstimateDeliveryDateTime ? dateFormate(jobcardDetailsByIdGet === null || jobcardDetailsByIdGet === void 0 || (_jobcardDetailsByIdGe6 = jobcardDetailsByIdGet.data) === null || _jobcardDetailsByIdGe6 === void 0 ? void 0 : _jobcardDetailsByIdGe6.EstimateDeliveryDateTime) : "-"
    }), /*#__PURE__*/ React.createElement(CardDetails, {
        label: "Service advisor",
        value: (_jobcardDetailsByIdGe7 = jobcardDetailsByIdGet === null || jobcardDetailsByIdGet === void 0 || (_jobcardDetailsByIdGe8 = jobcardDetailsByIdGet.data) === null || _jobcardDetailsByIdGe8 === void 0 ? void 0 : _jobcardDetailsByIdGe8.ServiceAdvisorName) !== null && _jobcardDetailsByIdGe7 !== void 0 ? _jobcardDetailsByIdGe7 : "-"
    }), /*#__PURE__*/ React.createElement(CardDetails, {
        label: "Campaign",
        value: (_jobcardDetailsByIdGe9 = jobcardDetailsByIdGet === null || jobcardDetailsByIdGet === void 0 || (_jobcardDetailsByIdGe10 = jobcardDetailsByIdGet.data) === null || _jobcardDetailsByIdGe10 === void 0 ? void 0 : _jobcardDetailsByIdGe10.CampaignName) !== null && _jobcardDetailsByIdGe9 !== void 0 ? _jobcardDetailsByIdGe9 : "-"
    }))), /*#__PURE__*/ React.createElement(CardComponent, {
        title: "Vehicle details"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "14px",
        fontWeight: "500"
    }, (_Installbasedetails$d = Installbasedetails === null || Installbasedetails === void 0 || (_Installbasedetails$d2 = Installbasedetails.data) === null || _Installbasedetails$d2 === void 0 ? void 0 : _Installbasedetails$d2.RegistrationNo) !== null && _Installbasedetails$d !== void 0 ? _Installbasedetails$d : "-"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "12px",
        color: "#8593A3"
    }, "".concat((_Installbasedetails$d3 = Installbasedetails === null || Installbasedetails === void 0 || (_Installbasedetails$d4 = Installbasedetails.data) === null || _Installbasedetails$d4 === void 0 ? void 0 : _Installbasedetails$d4.ProductName) !== null && _Installbasedetails$d3 !== void 0 ? _Installbasedetails$d3 : "-", "(").concat((_Installbasedetails$d5 = Installbasedetails === null || Installbasedetails === void 0 || (_Installbasedetails$d6 = Installbasedetails.data) === null || _Installbasedetails$d6 === void 0 ? void 0 : _Installbasedetails$d6.ProductCode) !== null && _Installbasedetails$d5 !== void 0 ? _Installbasedetails$d5 : "-", ")")), /*#__PURE__*/ React.createElement(MuiStack, {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        sx: {
            backgroundColor: "#F4F7FA",
            borderRadius: "12px"
        },
        mt: 1,
        p: 1.5
    }, /*#__PURE__*/ React.createElement(CardDetails, {
        label: "Engine no.",
        value: (_Installbasedetails$d7 = Installbasedetails === null || Installbasedetails === void 0 || (_Installbasedetails$d8 = Installbasedetails.data) === null || _Installbasedetails$d8 === void 0 ? void 0 : _Installbasedetails$d8.EngineNo) !== null && _Installbasedetails$d7 !== void 0 ? _Installbasedetails$d7 : "-"
    }), /*#__PURE__*/ React.createElement(CardDetails, {
        label: "Chassis no.",
        value: (_Installbasedetails$d9 = Installbasedetails === null || Installbasedetails === void 0 || (_Installbasedetails$d10 = Installbasedetails.data) === null || _Installbasedetails$d10 === void 0 ? void 0 : _Installbasedetails$d10.VinNo) !== null && _Installbasedetails$d9 !== void 0 ? _Installbasedetails$d9 : "-"
    }), /*#__PURE__*/ React.createElement(CardDetails, {
        label: "Date of sale",
        value: Installbasedetails !== null && Installbasedetails !== void 0 && (_Installbasedetails$d11 = Installbasedetails.data) !== null && _Installbasedetails$d11 !== void 0 && _Installbasedetails$d11.SalesInvoiceDate ? dateFormate(Installbasedetails === null || Installbasedetails === void 0 || (_Installbasedetails$d12 = Installbasedetails.data) === null || _Installbasedetails$d12 === void 0 ? void 0 : _Installbasedetails$d12.SalesInvoiceDate) : "-"
    }))));
};
